<div [appBackgroundImage]="url" 
    (readyToDisplayImage)="imageReady($event)" 
    [ngClass]="{'image-container-thumbnail': type === 'thumbnail', 'image-container-modal-preview': type === 'preview'}" @pageAnimation>
</div>
<app-smash-loading-spinner [type]="type" *ngIf="!imageIsReady" class="image-loading-spinner"></app-smash-loading-spinner>
